import {
  SR_API_ACTION_JOB_UPDATE,
} from 'api/actionTypes';

export default async function updateJob(
  { state, apiClient },
  { jobId, updates }
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_JOB_UPDATE,
    state: state,
    payload: {
      jobId,
      updates,
    },
  });
}
